import React, { useEffect } from 'react';
import { Routes, Route } from 'react-router-dom';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './assets/css/style.css';
import AOS from 'aos';
import 'aos/dist/aos.css';
import ScrollToTop from './ScrollToTop';
import Header from './componants/Header';
import DynamicPage from './componants/DynamicPage';
import Footer from './componants/Footer';
import { useDataContext } from './DataContext';

const originalFetch = window.fetch;
let pendingTokenPromise = null;

function executeRecaptcha() {
    return new Promise((resolve) => {
        let attempts = 0;
        const maxAttempts = 50; // 5 seconds max waiting time

        const checkInterval = setInterval(() => {
            attempts++;

            if (window.grecaptcha && typeof window.grecaptcha.ready === 'function') {
                clearInterval(checkInterval);

                window.grecaptcha.ready(() => {
                    window.grecaptcha
                        .execute(global.config.reCAPTCHAkey, { action: 'get_public_token' })
                        .then((token) => resolve(token))
                        .catch((err) => {
                            console.error("reCAPTCHA execution error:", err);
                            resolve(null);
                        });
                });
            } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                console.error("Timeout: Google reCAPTCHA script took too long to load.");
                resolve(null);
            }
        }, 100);
    });
}

async function requestPublicSession() {
    if (pendingTokenPromise) {
        return pendingTokenPromise;
    }

    pendingTokenPromise = (async () => {
        try {
            const recaptchaToken = await executeRecaptcha();

            if (!recaptchaToken) {
                console.error("Cannot request guest session: reCAPTCHA token missing.");
                return false;
            }

            // Include credentials so the browser receives & saves the HttpOnly GUEST_JWT_TOKEN cookie
            const response = await originalFetch(`${global.config.API_URL}auth/public-token`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
                body: JSON.stringify({ recaptchaToken })
            });

            return response.ok;
        } catch (error) {
            console.error('Failed to establish public guest session via reCAPTCHA:', error);
            return false;
        } finally {
            pendingTokenPromise = null;
        }
    })();

    return pendingTokenPromise;
}

// Global fetch override ensuring credentials: 'include' for every API request
window.fetch = async function (...args) {
    let [resource, config] = args;
    config = config || {};
    config.credentials = 'include';

    const url = typeof resource === 'string' ? resource : resource.url;
    if (url && url.includes('/auth/public-token')) {
        return originalFetch(resource, config);
    }

    let response = await originalFetch(resource, config);
    if (response.status === 401) {
        const sessionEstablished = await requestPublicSession();
        if (sessionEstablished) {
            response = await originalFetch(resource, config);
        }
    }
    return response;
};

function App() {
  const { setGlobalData } = useDataContext();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${global.config.API_URL}global/all`);
        const result = await response.json();
        if (Array.isArray(result) && result.length > 0) {
            setGlobalData(result[0]);
        }
        if (global.config && global.config.IsPrint === true) { 
            console.info('GlobalData', result); 
        }
      } 
      catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    fetchData();

    AOS.init({
      duration: 1500,
      easing: 'ease-in-out',
      once: true,
      mirror: false,        
    });

    window.addEventListener("beforeprint", function() {
      var elements = document.querySelectorAll("[data-aos]");
      elements.forEach(function(element) {
        element.style.opacity = '1';
        element.style.transform = 'none';
        element.style.transition = 'none';
      });
    });
  }, [setGlobalData]);

  return (
    <div className="App">
        <ScrollToTop />
        <Header/>
        <Routes>
          <Route path="/*" element={<DynamicPage />} />
        </Routes>
        <Footer/>   
    </div>
  );
}

export default App;